import * as React from 'react';

import Course from '../modules/lessons/domain/aggregates/course/Course';
import {Link} from 'react-router-dom';
import Registry from './Registry';

export default class SectionSpawner {

	public static course (course: Course, subsections: object[] = []) {
		const me = Registry.getInstance().me;

		return [
			{ key: 'Home', content: <Link to={me.isOrganizationAccount() ? (course.getVisibility().isPrivate() ? '/dashboard/my-courses' : '/dashboard') : course.getVisibility().isPrivate() ? '/my-courses' : '/'}>{me.isOrganizationAccount() ? 'Dashboard' : 'Home'}</Link> },
			{ key: 'Course', content: course.getName(), active: subsections.length === 0 }
		];
	}
}


// WEBPACK FOOTER //
// ./code/project/global/SectionSpawner.tsx